import React from 'react';

/**
 * When no iFrame CollectJs fields exist, we should draw them,
 * otherwise, leave the existing fields
 * @returns
 */
function shouldDrawCollectJsFields() {
    const config = window.CollectJS.iframes;
    // is iframe defined in object
    if (config != null && typeof config == 'object' & Object.keys(config).length > 0) {
        const firstElem = config[`${Object.keys(config)[0]}`];
        // is iframe present in the dom
        const isVisible = !!document.querySelector(`iframe#${firstElem.id}`);
        return !isVisible;
    }
    return true;
}

export const configureCJS = () => {
        window.CollectJS.configure({
            callback: function (response) {
                const ptToken = "payment_token";
                let input = document.createElement("input");
                input.type = "hidden";
                input.name = ptToken;
                input.id = ptToken;
                input.value = response.token;
                const form = document.getElementById('paymentForm');

                // If token already exists from a previous failed submission, remove it
                const elem = document.getElementById(`${ptToken}`);
                if (elem) {
                    elem.remove();
                }

                // append the new token to the form and submit to server
                form.appendChild(input);
                form.requestSubmit();
            },
        });
    //}
};

function ccLoading() {
    return (<div>Loading...</div>);
}

function appendCollectJsToDom(resolve, reject) {
    const src = process.env.REACT_APP_COLLECT_JS_CDN;
    const publicNmiKey = process.env.REACT_APP_NMI_PUBLIC_TOKEN;
    const script = document.createElement("script");
    script.src = src;
    script.setAttribute('data-tokenization-key', publicNmiKey);
    script.onload = () => resolve();
    script.onerror = () => reject(Error("Failed to load Collect.js"));
    document.head.appendChild(script);
}

function isCollectJsLoaded() {
    return !!document.querySelector("script[src*='Collect.js']");
}

async function loadCollectJs(resolve) {
    return new Promise((resolve, reject) => {
        if (isCollectJsLoaded()) {
            resolve();
            return;
        }
        appendCollectJsToDom(configureCJS, reject);
    });
}

export function CcComponent({ children }) {
    let isReady = false;

    try {
        loadCollectJs(configureCJS);
        isReady = true;
    } catch {
        //isReady = true;
        return (<div>Error...</div>);
    }

    if (isReady) {
        return children;
    }

    return ccLoading();
}